<!--
 * @Author: Your Name
 * @Description: 安心充订单列表  
-->
<template>
  <scroll-layout class="anxinOrder-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'order:anxin:order:export'" type="plain" @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-operation-dialog
      title="申请退款"
      :show.sync="showRefund"
      width="500px"
      :before-confirm="onRefund">
      <div slot="content">
        <ykc-form ref="refundForm" :model="refundForm" :rules="refundRules">
          <ykc-form-item label="退款金额" prop="refundAmount">
            <ykc-input v-model="refundForm.refundAmount" :disabled="true"></ykc-input>
          </ykc-form-item>
          <ykc-form-item label="退款原因" prop="reason">
            <ykc-input
              v-model="refundForm.reason"
              type="textarea"
              maxlength="200"
              :autosize="{ minRows: 2 }"
              placeholder="请输入退款原因"></ykc-input>
          </ykc-form-item>
        </ykc-form>
      </div>
    </ykc-operation-dialog>
  </scroll-layout>
</template>
<script>
  import { code, getLastTime, offlineExport } from '@/utils';
  import { orderPage, barrierPage } from '@/service/apis';

  export default {
    name: 'anxinOrderList',
    components: {},
    inject: ['reload'],
    data() {
      return {
        searchParams: {
          date: [], //
          carNumber: '', //
          createdTimeStart: '', //
          createdTimeEnd: '', //
          userPhone: '', //
          stationId: '', //
          tradeSeq: '', //
          discountNo: '',
          recordIds: [],
          orderStatus: '', // 订单状态
        },
        stationIdData: [],
        tableTitle: '订单列表',
        tableData: [],
        tableOperateButtons: [
          // {
          //   id: '1',
          //   enabled: () => code('order:anxin:order:detail'),
          //   text: '详情',
          //   handleClick: (btn, { row }) => {
          //     this.$router.push({
          //       path: '/orderManagement/anxinOrder/Detail',
          //       query: { recordId: row.recordId, gunCode: row.gunCode },
          //     });
          //   },
          // },
          {
            id: '2',
            enabled: () => code('order:anxin:order:detail'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.orderStatus !== 5}
                onClick={() => {
                  this.refundItem = row;
                  this.refundForm = {
                    refundAmount: '0.5',
                    reason: '',
                  };
                  this.showRefund = true;
                }}>
                申请退款
              </ykc-button>
            ),
          },
        ], // 列表操作
        tableColumns: [
          { label: '充电单号', prop: 'tradeSeq', minWidth: '200px', id: 0 },
          { label: '合作方单号', prop: 'partnerOrderNo', minWidth: '200px', id: 38 },
          { label: '枪编码', prop: 'carNumber', minWidth: '200px', id: 38 },
          { label: '充电用户', prop: 'userPhone', minWidth: '220px', id: 1 },
          { label: '订单金额(元)', prop: 'insuranceAmount', minWidth: '120px', id: 3 },
          { label: '订单状态', prop: 'orderStatusDesc', minWidth: '180px', id: 41 },
          { label: '退款时间', prop: 'refundTime', minWidth: '180px', id: 41 },
          { label: '订单创建时间', prop: 'createdTime', minWidth: '150px', id: 12 },
          { label: '订单修改时间', prop: 'modifiedTime', minWidth: '150px', id: 13 },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        showRefund: false,
        refundItem: {},
        refundForm: {
          refundAmount: '0.5',
          reason: '',
        },
        refundRules: {
          refundAmount: [
            { required: true, message: '请输入退款金额', trigger: 'blur' },
            { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' },
          ],
          reason: [
            { required: true, message: '请输入退款原因', trigger: 'blur' },
            { max: 200, message: '最多输入200字', trigger: 'blur' },
          ],
        },
      };
    },
    created() {
      // 页面跳转传参
      if (this.$route.query.data) {
        const query = JSON.parse(this.$route.query.data);
        console.log('query+++', query);

        if (query.recordIds && query.recordIds !== null) {
          this.searchParams.recordIds = query.recordIds;
        }
      }

      // 近30天初始化时间
      if (this.searchParams.recordIds && this.searchParams.recordIds.length) {
        this.searchParams.date = [];
        this.searchParams.createdTimeStart = '';
        this.searchParams.createdTimeEnd = '';
      } else {
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);
        this.searchParams.date = [startDate, endDate];
        this.searchParams.createdTimeStart = startDate;
        this.searchParams.createdTimeEnd = endDate;
      }

      this.requestStationData();
      this.requestList();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '订单创建时间',
            placeholder: '请选择创建时间',
          },
          {
            comName: 'YkcInput',
            key: 'userPhone',
            label: '用户账号',
            placeholder: '请输入用户账号',
          },

          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            comName: 'YkcInput',
            key: 'carNumber',
            label: '终端编码',
            placeholder: '请输入终端编码',
          },
          {
            comName: 'YkcDropdown',
            key: 'orderStatus',
            label: '订单状态',
            placeholder: '请选择订单状态',
            data: [
              { id: '0', name: '待投保' },
              { id: '1', name: '投保中' },
              { id: '2', name: '投保成功' },
              { id: '3', name: '投保失败' },
              { id: '4', name: '已退保' },
              { id: '5', name: '已完成' },
              { id: '6', name: '已退款' },
            ],
          },
        ];
      },
    },
    methods: {
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'insurance_order',
          jsonNode: {
            ...this.searchParams,
            tradeTimeStart: this.searchParams.createdTimeStart,
            tradeTimeEnd: this.searchParams.createdTimeEnd,
          },
        });
      },

      /**
       * 获取归属电站数据
       */
      requestStationData() {
        barrierPage
          .findThirdStationList({})
          .then(res => {
            console.log('获取归属电站数据+++++', res);
            this.stationIdData = res.map(item => ({
              id: item.stationId,
              name: item.stationName,
            }));
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);

        if (searchData.date && searchData.date.length > 0) {
          [this.searchParams.createdTimeStart, this.searchParams.createdTimeEnd] = searchData.date;
        }
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        console.log('清空查询', form);
        Object.assign(this.searchParams, form);

        // 近30天初始化时间
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);

        this.searchParams.date = [startDate, endDate];
        this.searchParams.createdTimeStart = startDate;
        this.searchParams.createdTimeEnd = endDate;
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 申请退款
       */
      applyRefund(row) {
        this.refundItem = row;
        this.showRefund = true;
        // 重置表单，退款金额固定为0.5元
        this.refundForm = {
          refundAmount: '0.5',
          reason: '',
        };
        this.$nextTick(() => {
          if (this.$refs.refundForm) {
            this.$refs.refundForm.clearValidate();
          }
        });
      },
      /**
       * 处理退款
       */
      onRefund() {
        this.$refs.refundForm.validate(valid => {
          if (valid) {
            const params = {
              tradeReq: this.refundItem.tradeSeq,
              refundAmount: Number(this.refundForm.refundAmount),
              reason: this.refundForm.reason,
            };
            orderPage
              .applyInsureOrderRefund(params)
              .then(res => {
                this.$message.success('提交成功');
                this.showRefund = false;
                this.requestList();
              })
              .catch(err => {
                console.log(err);
                this.$message.error('退款申请失败');
              });
          }
        });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        orderPage
          .anxinChargingOrderPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .anxinOrder-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }
        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }
        .cell .status-red {
          color: #d0021b;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  ::v-deep.customForm .el-form-item,
  ::v-deep.customForm .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
</style>
